"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Datalog = /*#__PURE__*/function () {
  function Datalog(robonomics) {
    _classCallCheck(this, Datalog);

    this.robonomics = robonomics;
  } // consts


  _createClass(Datalog, [{
    key: "maxId",
    value: function maxId() {
      var windowSize = this.robonomics.api.consts.datalog.windowSize;
      return windowSize.toNumber() - 1;
    } // queries

  }, {
    key: "getIndex",
    value: function () {
      var _getIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(address) {
        var index;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.robonomics.api.query.datalog.datalogIndex(address);

              case 2:
                index = _context.sent;
                return _context.abrupt("return", {
                  start: index.start.toNumber(),
                  end: index.end.toNumber()
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getIndex(_x) {
        return _getIndex.apply(this, arguments);
      }

      return getIndex;
    }()
  }, {
    key: "readByIndex",
    value: function () {
      var _readByIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(address, index) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.robonomics.api.query.datalog.datalogItem([address, index]);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readByIndex(_x2, _x3) {
        return _readByIndex.apply(this, arguments);
      }

      return readByIndex;
    }() // extrinsics

  }, {
    key: "write",
    value: function write(data) {
      return this.robonomics.api.tx.datalog.record(data);
    } // events

  }, {
    key: "on",
    value: function () {
      var _on = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var filter,
            cb,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                filter = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                cb = _args3.length > 1 ? _args3[1] : undefined;
                return _context3.abrupt("return", this.robonomics.on(_objectSpread(_objectSpread({}, filter), {}, {
                  section: "datalog",
                  method: "NewRecord"
                }), function (result) {
                  cb(result.map(function (item) {
                    return {
                      account: item.data[0],
                      success: item.success,
                      moment: item.data[1],
                      data: item.data[2]
                    };
                  }));
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function on() {
        return _on.apply(this, arguments);
      }

      return on;
    }() // helpers

  }, {
    key: "getLastId",
    value: function () {
      var _getLastId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(address) {
        var id, full, index, max;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = null;
                full = false;
                _context4.next = 4;
                return this.getIndex(address);

              case 4:
                index = _context4.sent;

                if (index.start != index.end) {
                  id = index.end - 1;
                  max = this.maxId();

                  if (id < 0) {
                    id = max;
                  }

                  if (index.start > 0 || index.end === max) {
                    full = true;
                  }
                }

                return _context4.abrupt("return", {
                  id: id,
                  full: full
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getLastId(_x4) {
        return _getLastId.apply(this, arguments);
      }

      return getLastId;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(address) {
        var start,
            end,
            log,
            id,
            index,
            data,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                start = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 0;
                end = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
                log = [];

                if (end) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 6;
                return this.getLastId(address);

              case 6:
                id = _context5.sent;

                if (!id.full) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 10;
                return this.read(address, id.id + 1, this.maxId());

              case 10:
                _context5.t0 = _context5.sent;
                _context5.next = 13;
                return this.read(address, 0, id.id);

              case 13:
                _context5.t1 = _context5.sent;
                return _context5.abrupt("return", _context5.t0.concat.call(_context5.t0, _context5.t1));

              case 17:
                end = id.id;

              case 18:
                if (!(end !== null)) {
                  _context5.next = 28;
                  break;
                }

                index = start;

              case 20:
                if (!(index <= end)) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 23;
                return this.readByIndex(address, index);

              case 23:
                data = _context5.sent;
                log.push(data);

              case 25:
                index++;
                _context5.next = 20;
                break;

              case 28:
                return _context5.abrupt("return", log);

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function read(_x5) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }]);

  return Datalog;
}();

exports["default"] = Datalog;